import { lazy } from 'react';
import { Route, Outlet } from 'react-router-dom';
import HesOutlet from '@/navigation/HesOutlet';

const Dashboard = lazy(() => import('@/pages/hes/dashboard'));

const BlockLoad = lazy(
  () => import('@/pages/hes/meter-profile-data/block-load')
);
const PushEvents = lazy(() => import('@/pages/hes/push-events'));
const DailyLoad = lazy(
  () => import('@/pages/hes/meter-profile-data/daily-load')
);
const MonthlyBilling = lazy(
  () => import('@/pages/hes/meter-profile-data/monthly-billing')
);
const InstantaneousProfile = lazy(
  () => import('@/pages/hes/meter-profile-data/instantaneous-profile')
);

const NamePlateDetail = lazy(
  () => import('@/pages/hes/meter-profile-data/name-plate-detail')
);

const PeriodicPush = lazy(
  () => import('@/pages/hes/meter-profile-data/periodic-push')
);

const MeterRelayStatus = lazy(() => import('@/pages/hes/meter-relay-status'));
const RealTimeClock = lazy(() => import('@/pages/hes/realtime-clock'));
const RFMeterFirmwareUpgrade = lazy(
  () => import('@/pages/hes/rf-firmware-upgrade')
);
const DCUFirmwareUpgrade = lazy(
  () => import('@/pages/hes/dcu-firmware-upgrade')
);
const DeviceInformation = lazy(() => import('@/pages/hes/device-information'));

const MeterStatistics = lazy(() => import('@/pages/hes/meter-statistics'));

const ConfigureCommand = lazy(() => import('@/pages/hes/configure-command'));
const CommandExecution = lazy(
  () => import('@/pages/hes/command/command-execution')
);
const CommandExecutionHistory = lazy(
  () => import('@/pages/hes/command/command-execution-history')
);
const ExecutionHistory = lazy(
  () => import('@/pages/hes/command/execution-history')
);

const VoltageEvents = lazy(
  () => import('@/pages/hes/pull-events/voltage-events')
);
const CurrentEvents = lazy(
  () => import('@/pages/hes/pull-events/current-events')
);
const PowerEvents = lazy(
  () => import('@/pages/hes/pull-events/power-related-events')
);
const NonRollOverEvents = lazy(
  () => import('@/pages/hes/pull-events/non-roll-over-events')
);
const ControlEvents = lazy(
  () => import('@/pages/hes/pull-events/control-events')
);
const OtherEvents = lazy(() => import('@/pages/hes/pull-events/other-events'));
const TransactionalEvents = lazy(
  () => import('@/pages/hes/pull-events/transactional-events')
);

const TOD = lazy(() => import('@/pages/hes/meter-profile-data/tod'));

const HesRoutes = (
  <Route
    path="hes"
    element={<HesOutlet />}>
    <Route
      index
      element={<Dashboard />}
    />

    <Route
      path="meter-relay-status"
      element={<MeterRelayStatus />}
    />

    <Route
      path="realtime-clock"
      element={<RealTimeClock />}
    />

    {import.meta.env.VITE_LEGACY_RF_FW_UPGRADE_BASE_URL && (
      <Route
        path="rf-firmware-upgrade"
        element={<RFMeterFirmwareUpgrade />}
      />
    )}

    {import.meta.env.VITE_LEGACY_DCU_FW_UPGRADE_BASE_URL && (
      <Route
        path="dcu-firmware-upgrade"
        element={<DCUFirmwareUpgrade />}
      />
    )}

    <Route
      path="meter-profile-data"
      element={<Outlet />}>
      <Route
        index
        element={<BlockLoad />}
      />
      <Route
        path="block-load"
        element={<BlockLoad />}
      />
      <Route
        path="daily-load"
        element={<DailyLoad />}
      />
      <Route
        path="monthly-billing"
        element={<MonthlyBilling />}
      />
      <Route
        path="instantaneous-profile"
        element={<InstantaneousProfile />}
      />
      <Route
        path="periodic-push"
        element={<PeriodicPush />}
      />
      <Route
        path="name-plate-detail"
        element={<NamePlateDetail />}
      />
      {import.meta.env.VITE_PROJECT_NAME === 'sangai' && (
        <Route
          path="tod"
          element={<TOD />}
        />
      )}
    </Route>

    <Route
      path="command"
      element={<Outlet />}>
      <Route
        index
        element={<CommandExecution />}
      />
      <Route
        path="command-execution"
        element={<CommandExecution />}
      />
      <Route
        path="command-execution-history"
        element={<CommandExecutionHistory />}
      />
      <Route
        path=":batchId"
        element={<ExecutionHistory />}
      />
    </Route>

    <Route
      path="device-information"
      element={<DeviceInformation />}
    />
    <Route
      path="meter-statistics"
      element={<MeterStatistics />}
    />

    <Route
      path="configure-command"
      element={<ConfigureCommand />}
    />

    <Route
      path="alarms"
      element={<PushEvents />}
    />

    <Route
      path="events"
      element={<Outlet />}>
      <Route
        index
        element={<VoltageEvents />}
      />
      <Route
        path="voltage-events"
        element={<VoltageEvents />}
      />
      <Route
        path="current-events"
        element={<CurrentEvents />}
      />
      <Route
        path="power-related-events"
        element={<PowerEvents />}
      />
      <Route
        path="non-roll-over-events"
        element={<NonRollOverEvents />}
      />
      <Route
        path="control-events"
        element={<ControlEvents />}
      />
      <Route
        path="other-events"
        element={<OtherEvents />}
      />
      <Route
        path="transactional-events"
        element={<TransactionalEvents />}
      />
    </Route>
  </Route>
);

export default HesRoutes;
